/**
 * External dependencies
 */
import WMUHideAndSeek from '@wakemeup/hide-and-seek';

/**
 * Internal dependencies
 */
import Front from './front';

/**
 * 
 */
class Header {

	/**
	 * @type HTMLElement
	 */
	element = null;

	/**
	 * @type Front
	 */
	front = null;

	/**
	 * @type WMUHideAndSeek
	 */
	hideAndSeek = null;

	/**
	 * @type Number
	 */
	lastHeight = null;

	/**
	 * @type String
	 */
	selector = '.site-header';

	/**
	 * @type String
	 */
	styleVarHeight = '--wmu-header-height';

	/**
	 * 
	 * @var {Front} front
	 */
	constructor( front )
	{
		this.front = front;
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		
	}

	/**
	 * 
	 */
	checkHeight()
	{
		if ( null === this.element ) return;

		if ( this.element.clientHeight != this.lastHeight )
		{
			this.lastHeight = this.element.clientHeight;
			this.front.styles.updateEntry( 'header', `body { ${this.styleVarHeight}:${this.lastHeight}px; }` );
		}
	}

	/**
	 * 
	 */
	setup()
	{
		this.element = document.querySelector( this.selector );
	}

	/**
	 * 
	 */
	setupHideAndSeek()
	{
		this.hideAndSeek = new WMUHideAndSeek( this.selector );
	}

}

export default Header;